export const PURCHASE_INVOICES = 'accounting/purchase_invoices/';

export const DATE_FORMAT = 'YYYY-MM-DD';

export const SIDE_MENU_KEY = 'sideMenu';

export const SERVICE_DESK_URL = 'https://issues.belitsoft.com/servicedesk/customer/portal/10'


// WEBPACK FOOTER //
// ./src/constants/index.js